import { makeStyles } from '@material-ui/core'

export const filterStyles = makeStyles((theme: any) => {
    return {
        formWrapper: {
            justifyContent: 'space-between',
            height: theme.history.filterHeight,
            alignItems: 'flex-start',
            paddingTop: theme.spacing(2),
        },
        searchWrapper: {
            // display: 'flex',
            alignItems: 'center',
        },
        filter: {
            paddingLeft: theme.spacing(1),
        },
        filterButtonWrapper: {
            position: 'relative',
            top: '10px',
            paddingLeft: theme.spacing(2),
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
        },
        input: {
            backgroundColor: '#f5f5f5', 
            borderRadius: theme.shape.borderRadius, 
            overflow: 'hidden',
            border: '1px solid #ddd',
    
            '& .MuiFilledInput-root': {
                backgroundColor: '#f5f5f5', 
                borderRadius: theme.shape.borderRadius, 
                paddingBottom: '6px',
                height: '40px',
                boxShadow: 'none',
                '&:before, &:after': {
                    display: 'none', 
                },
            },
            '& .MuiFilledInput-input': {
            padding: '17px 12px 10px 0px'
        },
            '& .MuiInputLabel-root': {
                top: '-7px', 
                fontSize: '0.9rem', 
                // color: '#9e9e9e',
            },
            '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
                marginTop: '8px',
            },
        }
    }
})

